export interface IForecastCard {
    hour: string;
    day: string;
    description: string;
    temperature: string;
    humidity: string;
    wind: string;
    dewPoint: string;
    iconCode: number;
    feelsLike: string;
    precipitation: string;
}

export enum CardDetailLabels {
    humidity = 'humidity',
    wind = 'wind',
    dewPoint = 'dewpoint'
}

export interface ILocationSolarDateTime {
    SunriseDateTimeLocal: string;
    SunsetDateTimeLocal: string;
}

export interface IHourlyForecastPeriod {
    forecastDateLocalStr: string;
    forecastDateUtcSt: string;
    cloudCoverPercent: number;
    description: string;
    dewPoint: number;
    feelsLike: number;
    iconCode: number;
    precipCode: number;
    precipProbability: number;
    adjustedPrecipProbability: number;
    precipRate: number;
    relativeHumidity: number;
    temperature: number;
    thunderstormProbability: number;
    windDirectionDegrees: number;
    windSpeed: number;
}

export interface HourlyForecastPeriodCompact {
    fdtolcl: string;
    ic: number;
    t: string | number;
    ccp: number;
    d: string;
    dpt: number;
    flt: number;
    pt: number;
    pp: number;
    app: number;
    pr: number;
    rh: number;
    tp: number;
    wd: number;
    ws: number;
    sp: number;
    sr: number;
    sd: number;
    gt: number;
    wbt: number;
}

export type HourlyForecastPeriodFromServer = {
    IconURLSmall: string;
    IconURLLarge: string;
    AbbreviatedTimeLocalStr: string;
    TemperatureDisplay: string;
    FeelsLikeDisplay: string;
    DewPointDisplay:  string;
    WindDirectionDegreesLabel: string;
    Slug: string;
    ForecastDateTimeOffsetLcl: string;
    IconCode: number;
    Temperature: number;
    CloudCoverPercent100: number;
    Description: string;
    DewPointTemperature: number;
    FeelsLikeTemperature: number;
    PrecipType: number;
    PrecipProbabilityPercent100: number;
    AdjustedPrecipProbabilityPercent100: number;
    PrecipRate: number;
    RelativeHumidityPercent100: number;
    ThunderstormProbabilityPercent100: number;
    WindDirection: number;
    WindSpeed: number;
    SurfacePressure: number;
    SnowRate: number;
    SnowDepth: number;
    GlobeTemperature: number;
    WetBulbTemperature: number;
    DisplayPrecipRate: number;
}

export type ToggleMobileHourlyCardDetailsType = {
    [key: number]: boolean;
}

export enum ScrollDirections {
    left = 'left',
    right = 'right'
}

export interface ScrollButtonStatus {
    isRightScrollButtonDisabled: boolean;
    isLeftScrollButtonDisabled: boolean;
}

export interface SideScrollType {
    isMouseBtnDown: boolean;
    left: number;
    top: number;
    x: number;
    y: number;
}

export enum HourlyForecastChartTypes {
    precip = 'precip',
    temp = 'temp'
}

export enum HourlyForecastYChartKeyTypes {
    temperature = 't',
    precipitation = 'app'
}
export interface ChartHourlyForecastPeriodCompact extends HourlyForecastPeriodCompact {
    originalAdjustedPrecipProbability?: number;
    plottedPointXPosition: number;
}
export interface IChartHourlyForecastPeriod extends IHourlyForecastPeriod {
    originalAdjustedPrecipProbability?: number;
    plottedPointXPosition: number;
}

export interface DailyForecastPeriod {
    detailedDescription?: string;
    isNightTimePeriod?: boolean;
    summaryDescription?: string;
    forecastDateLocalStr?: string;
    forecastDateUtcStr?: string;
    iconCode?: number;
    temperature?: string;
}

export interface DayNightPeriods {
    day: DailyForecastPeriod | null; // can be null
    night: DailyForecastPeriod;
}

export type ExpandedDailyCardsRecordType = {
    [key: number]: boolean;
}

export enum ForecastPageIds {
    hourly = 'forecasts/hourly',
    daily = 'forecasts/daily'
}

export interface DailyForecastPeriodsFromServer {
    Day:   DailyForecastPeriodFromServer | null;
    Night: DailyForecastPeriodFromServer;
}

export interface DailyForecastPeriodFromServer {
    IconCode: number;
    SummaryDescription: string;
    Temperature: string;
    DetailedDescription: string;
    ForecastDateLocalStr: string;
    ForecastDateUtcStr: string;
    IsNightTimePeriod: boolean;
    HasHourlyForecasts: boolean;
    IsToday: boolean;
    IsWeekendStart: boolean;
    IsWeekendEnd: boolean;
    TemperatureDisplay: string;
    IconURLSmall: string;
    IconURLLarge: string;
}

export interface TransformedServerResponseForClient {
    forecastDaily: DayNightPeriods[];
    chart: {
        minTemp: number;
        maxTemp: number;
    };
}